import { render } from "./ObjectCaroussel.vue?vue&type=template&id=f9751ee2"
import script from "./ObjectCaroussel.vue?vue&type=script&lang=js"
export * from "./ObjectCaroussel.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__